const CREATOR_PROFILE_TEST_IDS = {
  MAIN: 'creator-profile',
  HEADER__DISPLAY_NAME: 'header__display-name',
  HEADER__COLLABORATE_BUTTON: 'header__collaborate-button',
  HEADER__ADD_TO_LIST_BUTTON: 'header__add-to-list-button',
  HEADER__RECRUIT_TO_CRM_BUTTON: 'header__recruit-to-crm-button',
  HEADER__PROFILE_INFO: 'header__profile-info',
  HEADER__INVITE_TO_CAMPAIGN_BUTTON: 'header__invite-to-campaign-button',
  HEADER__RATING: 'header__rating',
  HEADER__COMPLETED_GIGS: 'header__completed_gigs',
  HEADER__LAST_ACTIVE: 'header__last_active',
  HEADER__SOCIAL_NETWORKS: 'header__social-networks',
  HEADER__MEMBERSHIP_LABELS: 'header__membership-labels',
  HEADER__PLATFORM_FOLLOWERS: 'header__platform-followers',
  HEADER__STATS_ROW: 'header__stats-row',
  HEADER__AUTHENTICITY_BADGE: 'header__authenticity-badge',
  HEADER__SAFE_COLLAB_BADGE: 'header__safe-collab-badge',
  HEADER__ACTIONS: 'header__actions',
  HEADER__MESSAGE_BUTTON: 'header__message-button',
  HEADER__VET_BUTTON: 'header__vet-button',
  HEADER__OVERFLOW_MENU: 'header__overflow-menu',
  TAB__OVERVIEW: 'tab__overview',

  TAB__OVERVIEW__TAGS_AND_CONTENT_PREFERENCES: 'profile-tags',
  TAB__OVERVIEW__BIO: 'profile-bio',
  TAB__OVERVIEW__METRICS_SUMMARY: 'tab__overview__metrics-summary',
  TAB__OVERVIEW__METRICS_SUMMARY__PLATFORM_DROPDOWN:
    'tab__overview__metrics-summary__platform-dropdown',
  TAB__OVERVIEW__METRICS_SUMMARY__SEE_ALL_ANALYTICS:
    'tab__overview__metrics-summary__see-all-analytics',

  TAB__ANALYTICS_AUDIENCE: 'tab__analytics-audience',

  TAB__ANALYTICS_AUDIENCE__TIKTOK_SOCIAL_HEALTH: 'tiktok-social-health',
  TAB__ANALYTICS_AUDIENCE__IDENTITY_SOCIAL_HEALTH: 'identity-social-health',
  TAB__POSTS: 'tab__posts',

  TAB__OVERVIEW__PORTFOLIO: 'tab__overview__portfolio',
  TAB__OVERVIEW__PORTFOLIO_SEE_POSTS: 'tab__overview__portfolio-see-posts',

  CAMPAIGN_HISTORY: 'campaign-history',
  CAMPAIGN_HISTORY__STAT_CAMPAIGNS: 'campaign-history__stat-campaigns',
  CAMPAIGN_HISTORY__STAT_RATING: 'campaign-history__stat-rating',
  CAMPAIGN_HISTORY__STAT_TIER: 'campaign-history__stat-tier',
  CAMPAIGN_HISTORY__TOGGLE: 'campaign-history__toggle',
  CAMPAIGN_HISTORY__LIST: 'campaign-history__list',

  TAB__FLAGS: 'tab__flags',
  TAB__NOTES: 'tab__notes',

  MAIN__PUBLIC: 'creator-public-profile',
  PUBLIC_PROFILE__UPSELL_BANNER: 'public-profile__upsell-banner',

  MAIN__MODAL: 'creator-profile-modal',

  MAIN__SHARED_LIST: 'creator-profile-shared-list',
};

export default CREATOR_PROFILE_TEST_IDS;
